import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface ClinicFiscalSettingsSnapshot {
  focus_empresa_id: string | null;
  codigo_municipio_emitente: string | null;
  default_nfce_series: string | null;
  default_nfse_cnae: string | null;
  default_nfse_iss_rate: number | null;
  default_nfse_series: string | null;
  default_nfse_service_list_item: string | null;
}

export function useClinicFiscalSettings() {
  return useQuery<ClinicFiscalSettingsSnapshot | null>({
    queryKey: ["clinic-fiscal-settings-snapshot"],
    staleTime: 1000 * 60 * 5,
    queryFn: async () => {
      const { data: userData } = await supabase.auth.getUser();
      if (!userData.user) return null;

      const { data: profile } = await supabase
        .from("profiles")
        .select("current_clinic_id")
        .eq("id", userData.user.id)
        .maybeSingle();

      const clinicId = profile?.current_clinic_id;
      if (!clinicId) return null;

      const { data, error } = await supabase
        .from("clinic_fiscal_settings")
        .select("focus_empresa_id, codigo_municipio_emitente, default_nfce_series, default_nfse_cnae, default_nfse_iss_rate, default_nfse_series, default_nfse_service_list_item")
        .eq("clinic_id", clinicId)
        .maybeSingle();

      if (error) throw error;
      return data;
    },
  });
}
